import React from "react";
import { Link } from "react-router-dom";
import Headertop from '../components/Headertop';
import Navbar from '../components/Navbar';
import '../components/css/CourseStyle.css';
import Footer from '../components/Footer';
// import course1 from '../components/courses/csir-net1.png';
// import course2 from '../components/courses/csir-net2.png';
// import course3 from '../components/courses/csir-net3.png';
import tag from '../components/images/onlineTag.webp';
import banners from '../components/courses/ass-professercour.png';

function IITGate (){
    return (
        <>
            <Headertop /> 
            <Navbar />
            
            <section className="bg-red text-white">
                <img src={banners} className="courseBanner" alt="" />
            </section>

            <section className="py-3">
                <div className="container">
                    <nav aria-label="breadcrumbs">
                        <ol className="breadcrumbs">
                            <li className="breadcrumbs-item itemslist"><Link to="/"><i className="bi bi-house"></i></Link></li>
                            <li className="breadcrumbs-item active" aria-current="page">CSIR NET</li>
                        </ol>
                    </nav>
                </div>
            </section>

            <section className="py-5">
                <div className="container">
                    <div className="mb-5">
                        <h2 className="fw-bold">Assistant Professor Online Coaching</h2>
                        <p className="text-muted">Vigyan Vriksh offers one of the best online coaching for the Assistant Professor exam, HPSC Assistant Professor, RPSC Assistant Professor, UPPSC Assistant Professor & Lectureship, MPPSC Assistant Professor, and DSSSB, exclusively designed for Chemistry aspirants. We are providing comprehensive Recorded Video Lectures, live classes, doubt-solving sessions, and a Comprehensive Test tailored to the syllabus. The platform is known for its affordable pricing, experienced faculty, and interactive teaching methods. Vigyan Vriksh ensures in-depth coverage of all topics, helping students prepare effectively for the exam.</p>

                        <h3>Courses:</h3>
                        <ul>
                            <li>Haryana HPSC Assistant Professor Coaching</li>
                            <li>MPPSC Assistant Professor Coaching</li>
                            <li>RPSC Assistant Professor Coaching</li>
                            <li>UPPSC Assistant Professor & Lectureship Coaching</li>
                            <li>JKPSC Chemistry Coaching</li>
                            <li>UKPSC Chemistry Coaching</li>
                        </ul>

                        <p>Vigyan Vriksh's Assistant Professor Online Coaching provides one of the coaching experiences for aspirants preparing for the Assistant Professor exam. Our online coaching program is designed to help you achieve success and excel in this highly competitive exam. Join the Assistant Professor Online Coaching program at Vigyan Vriksh and embark on your journey toward success.</p>

                    </div>

                    <div className="row g-4">
                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-blue">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-display fs-3"></i></div>
                                    <h5 className="fw-bold">Blogs</h5>
                                    <p className="text-muted mb-0">Read Our Latest Blogs</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-pink">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-journal-text fs-3"></i></div>
                                    <h5 className="fw-bold">Online Courses</h5>
                                    <p className="text-muted mb-0">Access Our Latest Courses</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-green">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-clipboard-check fs-3"></i></div>
                                    <h5 className="fw-bold">Test Series</h5>
                                    <p className="text-muted mb-0">Practice with Our Mock Test</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="card shadow-sm border-0 rounded-4 text-center h-100 card-lightblue">
                                <div className="card-body">
                                    <div className="icon-circle mb-3"><i className="bi bi-book fs-3"></i></div>
                                    <h5 className="fw-bold">Books</h5>
                                    <p className="text-muted mb-0">Find Preparation Books</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="container my-5">    
                <h3 class="fw-bold mb-4">Assistant Professor Online Courses</h3>
                <div class="row g-4">
                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://appx-content-v2.classx.co.in/paid_course4/2025-04-15-0.9113103599084718.png" class="img-fluid" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/ap-2-year" class="text-dark" target="_blank">Assistant Professor All states - 2 Year Complete Package</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    {/* <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li> */}
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>Till </b>Exam</li>
                                </ul>
                                <div class="batch-strip my-2">ULTIMATE LIVE BATCH EXPERIENCE <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹11,499</span>
                                    <div class="discount mt-2 p-3">Live Interactive Classes<br/>Topic-wise, real-time sessions with India’s top faculty<br/>Ask doubts instantly — get cla</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/ap-2-year" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://appx-content-v2.classx.co.in/paid_course3/2025-10-05-0_3417076340341012.jpeg" class="img-fluid" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/manzil-pre-2-year" class="text-dark" target="_blank">Manzil 4000+ Ass. Professor 2 Year - PRE(MCQ)</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    {/* <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li> */}
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>12 </b>month</li>
                                </ul>
                                <div class="batch-strip my-2">Basic to Advance IIT JAM 2027 <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹4,499</span>
                                    <div class="discount mt-2 p-3">Recorded Classes<br/>Topic-wise, real-time sessions with India’s top faculty<br/>Ask doubts instantly — get clarity on the spot!<br/>Basic-to-Advanced Lectur</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/manzil-pre-2-year" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <img src={tag} alt="" className="tagicon" />
                        <div class="course-card position-relative p-3">
                            <img src="https://appx-content-v2.classx.co.in/paid_course3/2025-10-05-0_6776593858259334.jpeg" width="100%" alt="" />
                            <div class="p-3">
                                <h5 class="fw-semibold"><Link to="https://vigyanvariksh.classx.co.in/payment-page/manzil-pre-mains-2-year" class="text-dark" target="_blank">Manzil Ass Professor (Pre + Mains) 2 Year – MANZIL Batch</Link></h5>
                                <span class="badge bg-warning text-dark">NEW</span>
                                <span class="badge bg-light text-dark">Hinglish</span>
                                <i class="bi bi-whatsapp text-success fs-5 ms-2"></i>
                                <ul class="list-unstyled small text-muted mt-3">
                                    {/* <li><i class="bi bi-people me-2"></i>For CSIR NET, GATE & SET Aspirants</li> */}
                                    <li><b class="bi bi-clock me-2"></b>Valid for <b>12 </b>month</li>
                                </ul>
                                <div class="batch-strip my-2">ULTIMATE LIVE BATCH EXPERIENCE <span class="pro-badge">PRO</span></div>
                                <p>(For Champions Who Want to Crack It — Not Just Attempt It)</p>
                                <div class="my-3">
                                    <span class="price-new">₹5,499</span>
                                    <div class="discount mt-2 p-3">Recorded Lectures<br/>Full syllabus coverage through high-quality recorded video lectures.<br/>Learn at your own pace — anytime, anywhere.</div>
                                    <div class="small text-muted">(For Full Batch)</div>
                                </div>
                                <div class="d-flex gap-2">
                                    <Link to="#" class="btn btn-outline-danger flex-fill">EXPLORE</Link>
                                    <Link to="https://vigyanvariksh.classx.co.in/payment-page/manzil-pre-mains-2-year" class="btn btn-danger flex-fill" target="_blank">BUY NOW</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="text-center mt-4">
                    <Link to="#" class="btn btn-light border rounded-pill px-4 py-2 text-primary fw-semibold">View All Batches <i class="bi bi-arrow-right"></i></Link>
                </div>
            </section>

            <section className="container coursebox py-3">
                <div class="row g-4">
                    <h3>Assistant Professor Online Courses</h3>
                    <p>Vigyan Vriksh offers online courses for Assistant Professor Preparation of Chemistry subjects. The course includes HPSC Assistant Professor, RPSC Assistant Professor, UP PSC Assistant Professor, MPPSC Assistant Professor, and DSSSB Coaching. Each course is designed to cover the exam syllabus comprehensively, doubt-solving sessions, provide detailed explanations, practice PYQs questions, and mock tests to help students excel in their respective fields.</p>

                    <h3>Haryana HPSC Assistant Professor Online Coaching</h3>
                    <p>Vigyan Vriksh HPSC Assistant Professor Online Coaching provides a well-rounded preparation experience, including Recorded Video Lectures, Comprehensive Test, Doubt Sessions, and Previous Year Paper Discussions, tailored to the HPSC Assistant Professor Chemistry syllabus. The course structure is designed to cover key concepts, enhance problem-solving skills, and prepare students thoroughly for the exam.</p>

                    <p>Vigyan Vriksh Online Classes and doubt-clearing sessions ensure that learners get personalized attention and support. With guidance from expert faculty and innovative teaching strategies, Our aim is to help candidates achieve their best possible results in the Haryana HPSC Assistant Professor Chemistry Exam.</p>

                    <h3>MPPSC Assistant Professor Online Coaching</h3>
                    <p>Vigyan Vriksh offers online coaching for MPPSC Assistant Professor Chemistry, providing comprehensive guidance and resources to help you prepare effectively. Vigyan Vriksh's MPPSC Assistant Professor Online Coaching features recorded video lectures, Comprehensive Test, Doubt Sessions, Previous Year Paper Discussions, and expert tips tailored to the MPPSC Assistant Professor Chemistry syllabus. With interactive sessions and a focus on key concepts, Our aim is to enhance your understanding and boost your confidence for the MPPSC Assistant Professor Chemistry Exam.</p>

                    <h3>RPSC Assistant Professor Online Coaching</h3>
                    <p>The Disp Academy RPSC Online Courses are one of the RPSC Online Coaching for candidates preparing for teaching positions in government colleges across Rajasthan. Our online Batch will help the candidates prepare with ease. Faculty in Vigyan Vriksh's Online Coaching programs are familiar with the RPSC Assistant Professor Chemistry syllabus and exam pattern.</p>

                    <p>The candidates can always ask questions, participate actively with our teachers, and receive tailored coaching to improve their conceptual knowledge via interactive live sessions during the RPSC Classes. For comprehensive preparation, you will have access to live classes, recorded video lectures, Doubt Sessions, Comprehensive Test, and Previous Year Paper Discussions.</p>

                    <h3>UPPSC Assistant Professor & Lectureship Online Coaching</h3>
                    <p>Vigyan Vriksh offers online coaching for UPPSC Assistant Professor Chemistry, providing comprehensive preparation resources. Our UPPSC Assistant Professor & Lectureship Online Coaching includes recorded video lectures, a Comprehensive Test, and Doubt Sessions tailored for the Chemistry exam. The platform's expert faculty focuses on key concepts, problem-solving techniques, and previous years' question papers to ensure thorough understanding and exam readiness. Enroll for targeted preparation and boost your chances of success in the UPPSC Assistant Professor & Lectureship Chemistry Exam.</p>

                    <h3>JKPSC Chemistry Online Coaching</h3>
                    <p>Vigyan Vriksh offers a comprehensive online coaching program for JKPSC Chemistry, providing comprehensive guidance and resources for exam preparation. Vigyan Vriksh's JKPSC Online Coaching includes Recorded Video Lectures, Comprehensive Test, Doubt Clearing Sessions, Previous Year Paper Discussions, and Expert Tips tailored to the JKPSC Chemistry syllabus. With interactive sessions and a focus on key concepts, Our aim is to enhance your understanding and boost your confidence for the JKPSC Chemistry Exam.</p>

                    <h3>UKPSC Chemistry Online Coaching</h3>
                    <p>Vigyan Vriksh offers a comprehensive online coaching program for UKPSC Chemistry, providing comprehensive guidance and resources for exam preparation. Vigyan Vriksh's UKPSC Online Coaching includes Recorded Video Lectures, Comprehensive Test, Doubt Clearing Sessions, Previous Year Paper Discussions, and Expert Tips tailored to the UKPSC Chemistry syllabus. With interactive sessions and a focus on key concepts, Our aim is to enhance your understanding and boost your confidence for the UKPSC Chemistry Exam.</p>

                    <h3>Vigyan Vriksh Assistant Professor Online Coaching Fees</h3>
                    <p>Vigyan Vriksh offers affordable online coaching for the Assistant Professor exam, making it accessible for students preparing for the exam. Our Assistant Professor Online Coaching Fees are designed to be budget-friendly while providing comprehensive coverage of the syllabus and exam strategies. With a focus on delivering quality education at a reasonable cost, Vigyan Vriksh aims to support students effectively in their HPSC Assistant Professor, UPPSC Assistant Professor, MPPSC Assistant Professor, and UKPSC preparation journey.</p>


                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <th colSpan={2}>Previous Years Question Papers with Detail</th>
                            </tr>
                            <tr>
                                <td width='50%'>HPSC</td>
                                <td>Click Here</td>
                            </tr>
                            <tr>
                                <td>UPPSC</td>
                                <td>Click Here</td>
                            </tr>
                            <tr>
                                <td>RPSC</td>
                                <td>Click Here</td>
                            </tr>
                            <tr>
                                <td>UKPSC</td>
                                <td>Click Here</td>
                            </tr>
                            <tr>
                                <td>JKPSC</td>
                                <td>Click Here</td>
                            </tr>
                        </tbody>
                    </table>

                    <p>The table below provides a collection of CSIR NET previous years' question papers for various disciplines, including Life Sciences, Physical Sciences, Earth Sciences, Chemical Sciences, and Mathematical Sciences. Here is the table providing links to the previous year's question papers for each subjects.</p>


                    <table className="table table-bordered">
                        <tbody>
                            <tr>
                                <th colSpan={2}>CSIR NET Previous Years Question Papers Topic Wise</th>
                            </tr>
                            <tr>
                                <td width='50%'>Year Wise</td>
                                <td>Click Here</td>
                            </tr>
                            <tr>
                                <td>Topic wise Physical Chemistry</td>
                                <td>Click Here</td>
                            </tr>
                            <tr>
                                <td>Topic wise Organic Chemistry</td>
                                <td>Click Here</td>
                            </tr>
                            <tr>
                                <td>Topic wise Inorganic Chemistry</td>
                                <td>Click Here</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <Footer />
        </>
    );
}
export default IITGate;